<template>
  <div>
    <table width="100%">
      <tr>
     <td>
       <my-header v-bind:h1="type" v-bind:h2="degree" v-bind:h3="semester"></my-header>
     </td>
      </tr>

    </table>
    <table class="table table-header-rotated table-color " border="1" width="100%" style="margin-top:30px;border-collapse:collapse">
      <thead>
        <tr>
          <th width="5%" style="text-align: center; background-color:lightgray">
            Sr.No
          </th>
          <th width="20%" style="text-align: center; background-color:lightgray">
            Name
          </th>
          <th width="20%" style="text-align: center; background-color:lightgray">
            Father Name
          </th>

          <th width="20%" style="text-align: center; background-color:lightgray">
            Program
          </th>

          <th width="35%" style="text-align: center; background-color:lightgray">
            Remarks
          </th>

        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, ind) in student">
          <td align="center">{{ind+1}}</td>
          <td>{{item.Name}}</td>
          <td>{{item.FathersName}}</td>
          <td>{{item.Program}}</td>
          <td>{{item.Remarks}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        header: {Name:'',Logo:'',website:''},
        student: [],
        type: '',
        date: '',
        degree: '',
        semester:''
      }
    },


    created: function () {

      this.getprint();
    },
    methods: {
      getprint() {
        const params = new URLSearchParams(window.location.search);
        const degid = params.get('deg');
        const progid = params.get('prog');
        const semid = params.get('sem');
        const type = params.get('type');

        var vm = this;
        axios.post('/api/AdmissionApi/loadstudents?sem=' + semid + '&deg=' + degid + '&prog=' + progid + '&typ=' + type)
          .then(function (res) {
            vm.student = res.data.lst;
            vm.type = res.data.el + " Candidate list";
            vm.date = res.data.date;
            vm.header = res.data.inst;
            vm.semester = res.data.semester;
            vm.degree = res.data.degree;
          })
          .then(function (error) {
            console.log(error);
          })
      },

    }

  })
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/inEligibileCandidatesPrint.vue